import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { CategoryModel } from 'shared/api'
import { config } from 'translations'

import { cmsApiBaseUrl } from '../constants/urls'
import MenuItem from './MenuItem'

type PdfMenuItemProps = {
  category?: CategoryModel
  regionCode: string
  languageCode: string
  closeMenu?: () => void
}

const PdfMenuItem = ({ category, regionCode, languageCode, closeMenu, ...other }: PdfMenuItemProps): ReactElement => {
  const { t } = useTranslation()
  const pdfDisabled = config.hasRTLScript(languageCode)

  const pdfUrl =
    !category || category.isRoot()
      ? `${cmsApiBaseUrl}/${regionCode}/${languageCode}/wp-json/ig-mpdf/v1/pdf`
      : `${cmsApiBaseUrl}/${regionCode}/${languageCode}/wp-json/ig-mpdf/v1/pdf?url=${encodeURIComponent(category.path)}`

  return (
    <MenuItem
      icon={<DescriptionOutlinedIcon fontSize='small' />}
      text={t($ => $.categories.pdf.create)}
      to={pdfUrl}
      disabled={pdfDisabled}
      tooltip={pdfDisabled ? t($ => $.categories.pdf.disabled) : null}
      closeMenu={closeMenu}
      {...other}
    />
  )
}

export default PdfMenuItem
